import styled from 'styled-components';

export const VideoContainer = styled.div`
 max-width: 700px;
 height: 70vh;
 margin: 2rem auto 0 auto;
 background-color: ${props => props.bg};
 @media (max-width: 680px){
            height: auto;
        }
 iframe{
    width: 100%;
    height: 100%;
    @media (max-width: 680px){
      height: auto;
            min-height: 40vh;
        }
 }
`